<template>
  <div>
    <app-history
      @clicked="
        showDialog = true;
        currentMeal = initMeal;
      "
      title="افزودن  وعده غذایی"
    />

    <div>
      <v-data-table
        :items="meals"
        :headers="mealsHeaders"
        class="elevation-1 rounded"
        :disable-pagination="true"
        :hide-default-footer="true"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
      >
        <template v-slot:[`item.isActive`]="{ item }">
          {{ item.isActive ? "بله" : "خیر" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn class="dialogButton" rounded @click="editItem(item)"
            >ویرایش</v-btn
          >
          <v-btn class="dialogButton" rounded @click="removeItem(item)"
            >حذف</v-btn
          >
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="showDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> نام</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-select
            :items="names"
            item-text="text"
            item-value="value"
            v-model="currentMeal.name"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> زمان شروع</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="currentMeal.startTimeString"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> زمان پایان</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="currentMeal.endTimeString"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> ساعات مجاز رزرو </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentMeal.hbReserve"
            maxlength="3"
            :oninput="onInput"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> ساعات مجاز لغو </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentMeal.hbCancel"
            maxlength="3"
            :oninput="onInput"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> ترتیب نمایش </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="currentMeal.sort"
            maxlength="3"
            :oninput="onInput"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="10"> فعال </v-col>
        <v-col class="d-flex ltr" cols="2">
          <v-switch v-model="currentMeal.isActive"></v-switch>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn
          class="dialogButton"
          rounded
          @click="
            showDialog = false;
            isEdit = false;
          "
        >
          انصراف
        </v-btn>
      </v-row>
      <date-picker
        ref="datepicker1"
        v-model="currentMeal.startTimeString"
        :editable="false"
        :auto-submit="true"
        element="fileInput1"
        @change="onChangeDate($event, 1)"
        format="HH:mm"
        :jump-minute="5"
        :round-minute="true"
        type="time"
      ></date-picker>
      <input id="fileInput1" ref="fileInput1" />
      <date-picker
        ref="datepicker2"
        v-model="currentMeal.endTimeString"
        :editable="false"
        :auto-submit="true"
        element="fileInput2"
        :min="currentMeal.startTimeString"
        format="HH:mm"
        :jump-minute="5"
        :round-minute="true"
        type="time"
        @change="onChangeDate($event, 2)"
      ></date-picker>
      <input id="fileInput2" ref="fileInput2" />
    </v-dialog>
    <app-dialog @close="onCloseDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetBranchMeals, SaveMeal, DeleteMeal } from "@/api/meals";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showDialog: false,
      meals: [],
      currentMeal: {},
      initMeal: {
        name: "",
        startTimeString: "",
        endTimeString: "",
        hbReserve: "",
        hbCancel: "",
        sort: 0,
        isActive: true,
        id: "0",
      },

      isEdit: false,
      names: [
        { value: "صبحانه", text: "صبحانه" },
        { value: "ناهار", text: "ناهار" },
        { value: "شام", text: "شام" },
        { value: "سحري", text: "سحري" },
        { value: "افطاري", text: "افطاري" },
        { value: "میان وعده", text: "میان وعده" },
        { value: "ساير", text: "ساير" },
      ],
      mealsHeaders: [
        {
          text: "ترتیب نمایش",
          value: "sort",
          width: "10%",
        },
        {
          text: "نام",
          value: "name",
          width: "20%",
        },

        {
          text: "ساعت شروع",
          value: "startTimeString",
          width: "10%",
        },

        {
          text: "ساعت پایان",
          value: "endTimeString",
          width: "10%",
        },
        {
          text: "ساعات مجاز رزرو",
          value: "hbReserve",
          width: "10%",
        },

        {
          text: "ساعات مجاز لغو",
          value: "hbCancel",
          width: "10%",
        },
        {
          text: "فعال",
          value: "isActive",
          width: "5%",
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  created() {
    this.currentMeal = this.initMeal;
    if (this.currentBranch) this.GetBranchMeals();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },

  methods: {
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      if (input == 1) {
        this.currentMeal.startTimeString = $event.format("HH:mm");
      } else {
        this.currentMeal.endTimeString = $event.format("HH:mm");
      }
    },
    /**
     * expand khorooj
     */
    GetBranchMeals() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetBranchMeals(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.meals = response.data.items;

            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    editItem(item) {
      this.currentMeal = Object.assign({}, item);
      this.showDialog = true;
      this.isEdit = true;
    },
    removeItem(item) {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", item.id);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به حذف این وعده هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    applyRequest() {
      var text = "";

      if (this.currentMeal.name == "") {
        text = "فرد بایستی انتخاب شود.";
      } else if (this.currentMeal.startTimeString == "") {
        text = "زمان شروع بایستی انتخاب شود.";
      } else if (this.currentMeal.endTimeString == "") {
        text = "زمان پایان بایستی انتخاب شود.";
      } else if (this.startTimeString > this.endTimeString) {
        text = "زمان شروع بایستی پیش از زمان پایان باشد.";
      } else if (this.currentMeal.hbReserve == "") {
        text = "ساعات مجاز رزرو بایستی انتخاب شود.";
      } else if (this.currentMeal.hbCancel == "") {
        text = "ساعات مجاز لغو بایستی انتخاب شود.";
      } else if (this.currentMeal.sort == "") {
        text = "ترتیب نمایش بایستی انتخاب شود.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        SaveMeal(
          this.currentMeal.id,
          this.currentBranch.id,
          this.currentMeal.name,
          this.currentMeal.startTimeString,
          this.currentMeal.endTimeString,
          this.currentMeal.hbReserve,
          this.currentMeal.hbCancel,
          this.currentMeal.sort,
          this.currentMeal.isActive
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showDialog = false;
            this.GetBranchMeals();
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

    /**
     * call remove api if user click on yes
     */
    onCloseDialog(index) {
      if (index != -1) {
        DeleteMeal(index)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);

            if (data.success) {
              this.GetBranchMeals();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
  },
};
</script>
